import axios from 'axios';
import { apiInstancesLinksUrl } from '../config';

/**
 * DELETE Instance Links.
 *
 * @author Yves Matta <yves.matta@qochealth.com>
 * @param {{}} props
 * @param {{}} [props.requestConfig] - additional config for request
 * @param {string} [props.instanceLinkUUID] - target instanceLinkUUID
 * @param {string[]} [props.instanceLinkUUIDs] - array of target instanceLinkUUIDs
 * @returns {Promise}
 */
const deleteInstanceLinks = (props = {}) => {
  const { instanceLinkUUID, instanceLinkUUIDs, requestConfig } = props;

  const method = 'delete';
  const url = apiInstancesLinksUrl;
  const data = instanceLinkUUIDs || [instanceLinkUUID];

  return axios({
    data,
    method,
    url,
    ...requestConfig
  });
};

export default deleteInstanceLinks;



// WEBPACK FOOTER //
// ./src/qoc-sdk/library/deleteInstanceLinks.js